import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'

type Props = {
 open: boolean
 onClose: () => void
 languageVariants: {
  language_code: string
  language: string
 }[]
 selectedLang: string | null
 setSelectedLang: (val: string) => void
 children: React.ReactNode
}

const Preview = ({
 open,
 onClose,
 languageVariants,
 selectedLang,
 setSelectedLang,
 children,
}: Props) => {
 const {t} = useTranslation()
 const [openLang, setOpenLang] = useState(false)

 if (!open) return null

 return (
  <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/40'>
   <div className='bg-white w-[512px] rounded-3xl p-8 relative shadow-xl'>
    <button
     onClick={onClose}
     className='absolute right-6 top-7 bg-gray-200 rounded-full px-3 py-1'
    >
     x
    </button>

    <h2 className='text-2xl font-semibold mb-6'>
     {t('preview.preview')}
    </h2>

    {languageVariants.length > 0 && (
     <div className='mb-6 flex justify-center'>
      <div className='flex items-center gap-4 relative'>
       <p className='text-gray-600 font-medium whitespace-nowrap'>
        {t('preview.languagePreview')}
       </p>

       <div
        onClick={() => setOpenLang(!openLang)}
        className='border rounded-xl px-4 py-2 bg-white cursor-pointer flex justify-between items-center min-w-[160px]'
       >
        <span>
         {languageVariants.find(
          (l) => l.language_code === selectedLang
         )?.language || ''}
        </span>
        <span>▾</span>
       </div>

       {openLang && (
        <div className='absolute top-full right-0 mt-2 w-64 bg-white rounded-xl shadow-lg border z-50 overflow-hidden'>
         {languageVariants.map((v) => {
          const langCode = v.language_code
          const langName = v.language || langCode

          const isSelected = selectedLang === langCode

          return (
           <div
            key={langCode}
            onClick={() => {
             setSelectedLang(langCode)
             setOpenLang(false)
            }}
            className='flex items-center gap-3 px-4 py-3 hover:bg-gray-100 cursor-pointer'
           >
            <div
             className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
              isSelected
               ? 'border-blue-500'
               : 'border-gray-400'
             }`}
            >
             {isSelected && (
              <div className='w-2 h-2 bg-blue-500 rounded-full'></div>
             )}
            </div>

            <span className='text-sm'>{langName}</span>
           </div>
          )
         })}
        </div>
       )}
      </div>
     </div>
    )}

    {children}

    <button
     onClick={onClose}
     className='w-full mt-8 bg-[#0E7A41] text-white py-3 rounded-xl font-semibold'
    >
     {t('preview.okay')}
    </button>
   </div>
  </div>
 )
}

export default Preview
